/**
 * #5006 — participant presence across signaling's disconnect grace window.
 *
 * A transport failure does not remove a participant at once: signaling defers
 * cleanup so a suspended tab or a network blip can recover into the same
 * session. Until #5006 the room saw nothing during that window, so the tile of
 * someone who had already gone sat there with no stream — black — until the
 * grace expired.
 *
 * - `PARTICIPANT_LEAVING`: client → server, sent from `pagehide` when the page
 *   is really unloading. The disconnect that follows is a departure, not a
 *   suspend, and gets the short grace.
 * - `PARTICIPANT_SUSPENDED`: server → room, when a grace timer starts.
 * - `PARTICIPANT_RESUMED`: server → room, when that timer is cancelled by a
 *   recovery or a rejoin. Expiry is still announced by `USER_LEFT`.
 */
export const PARTICIPANT_LEAVING = 'participant:leaving';
export const PARTICIPANT_SUSPENDED = 'participant:suspended';
export const PARTICIPANT_RESUMED = 'participant:resumed';

export interface ParticipantSuspendedPayload {
  roomId: string;
  sessionId: string;
  /** How long signaling will wait before `USER_LEFT`. */
  graceMs: number;
}

export interface ParticipantResumedPayload {
  roomId: string;
  sessionId: string;
}
